import { AUTH_ROLES } from "api/common/types/auth.types";
import { useQuicksightReportsQuery } from "api/memberPortal/reports/quicksight/quicksight.api";
import { useAuth } from "hooks/useAuth";

import DashboardSection from "./components/DashboardSection";
import { legacyReports } from "./data/legacyReports";

const ReportsCenter = () => {
  const { data: dashboardList } = useQuicksightReportsQuery();
  const { permissions } = useAuth();

  if (!dashboardList) return null;

  return (
    <>
      {permissions.role_type === AUTH_ROLES.NIAP && (
        <DashboardSection title="NIAP Reports" dashboards={dashboardList} />
      )}
      <DashboardSection title="Legacy Reports" dashboards={legacyReports} />
    </>
  );
};

export default ReportsCenter;
